import { Component, EventEmitter, Input, Output } from "@angular/core";
@Component({
    template: '',
    standalone: false
})
export abstract class paginationParams {
    @Input({ required: true }) listData: Array<{ [key: string]: any }> = []
    @Input({ required: true }) nextpage: number = 0;
    @Input({ required: true }) prevPage: number | null = 0;
    @Input({ required: true }) currentPage: number = 1;
    @Input({ required: true }) limit: number = 10;
    @Input({ required: true }) totalPage: number = 0
    @Input({ required: true }) loader: boolean = false;

    ///Event Emiter 
    @Output() paginationEvent = new EventEmitter()

}